import APIKit from "../Allapis/Apikit/apikit";

export const getUserDetails = async (id) => {
  try {
    const url = `/admin/users/info/${id}`;
    const result = await APIKit.get(url);
    console.log(result.id);
    return result.data;
  } catch (e) {
    console.log(e);
    return e.response ? e.response.data : e;
  }
};

export const getUserList = async (params) => {
  try {
    const { name, email, role, from, to } = params;
    const url = `/admin/users/list`;
    const result = await APIKit.get(url, {
      params: { name, email, role, from, to },
    });
    console.log(result.data);
    return result.data;
  } catch (e) {
    console.log(e);
    return e.response ? e.response.data : e;
  }
};

export const userBlockUnblock = async (id, body) => {
  try {
    const url = `/admin/users/${id}`;
    const result = await APIKit.put(url, body);
    return result.data;
  } catch (error) {
    console.log(error);
    return error.response ? error.response.data : error;
  }
};
export const getUserLoginHistory = async (id, filters = {}) => {
  try {
    const url = `/users/info/${id}`;
    const result = await APIKit.get(url, {
      params: filters,
    });
    console.log(result.id);
    return result.data;
  } catch (e) {
    console.log(e);
    return e.response ? e.response.data : e;
  }
};
export const userUnlock = async (id, body) => {
  try {
    const url = `/admin/users/unlock/${id}`;
    const result = await APIKit.put(url, body);
    return result.data;
  } catch (error) {
    console.log(error);
    return error.response ? error.response.data : error;
  }
};

//Broker Portfolio Apis

export const getBrokerPortfolio = async (id) => {
  try {
    const url = `/admin/subscriptions/broker/stats/${id}`;
    const result = await APIKit.get(url);
    console.log({ result: result });
    return result.data;
  } catch (e) {
    console.log(e);
    return e.response ? e.response.data : e;
  }
};

export const getInvestorPortfolio = async (params) => {
  try {
    const url = `/admin/subscriptions/investors/stats/`;
    const result = await APIKit.get(url, { params: params });
    console.log(result.id);
    return result.data;
  } catch (e) {
    console.log(e);
    return e.response ? e.response.data : e;
  }
};
